// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yhKXZ{margin:16px 0 0 8px;color:#2d2d2d;font-family:\"Merriweather\",serif;font-size:26px;font-weight:700;line-height:30px}@media screen and (min-width:768px){.yhKXZ{margin:0;font-size:36px;line-height:44px}}@media screen and (min-width:1236px){.yhKXZ{margin:0}}._7MNGr .ina2-{padding-top:8px}@media screen and (min-width:768px){._7MNGr .ina2-{padding:16px 0 0}}._7MNGr .ina2-[data-first]{padding-top:16px}@media screen and (min-width:768px){._7MNGr .ina2-[data-first]{padding-top:24px}}._8O3mk{margin:16px 0}@media screen and (min-width:768px){._8O3mk{margin-bottom:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "yhKXZ",
	"page": "_7MNGr",
	"grid": "ina2-",
	"loader": "_8O3mk"
};
module.exports = ___CSS_LOADER_EXPORT___;
